export default {
  strict: true,
  namespaced: true,
  state: {
    airports: [],
    hotels: [],
    ports: [],
    universities: []
  },
  mutations: {
    cleanAirports (state) { state.airports = [] },
    cleanHotels (state) { state.hotels = [] },
    cleanPorts (state) { state.ports = [] },
    cleanUniversities (state) { state.universities = [] },
    setAirports (state, value) { state.airports = value },
    setHotels (state, value) { state.hotels = value },
    setPorts (state, value) { state.ports = value },
    setUniversities (state, value) { state.universities = value },
    sortList (state, data) {
      if (state[data.type].length < 0) {
        return
      }

      let lat = data.lat
      let lng = data.lng
      let list = state[data.type]

      state[data.type] = list.sort((lhs, rhs) => {
        let getDistance = (lat1, lng1, lat2, lng2) => {
          let radlat1 = Math.PI * lat1 / 180
          let radlat2 = Math.PI * lat2 / 180
          let theta = lng1 - lng2
          let radtheta = Math.PI * theta / 180
          let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) *
            Math.cos(radlat2) * Math.cos(radtheta)
          dist = Math.acos(dist)
          dist = dist * 180 / Math.PI
          dist = dist * 60 * 1.1515
          return dist
        }

        let lhsDistance = getDistance(lat, lng, lhs.lat, lhs.lng)
        let rhsDistance = getDistance(lat, lng, rhs.lat, rhs.lng)

        if (lhsDistance < rhsDistance) { return -1 }
        if (rhsDistance < lhsDistance) { return 1 }
        return 0
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/static-locations.js